export const TransactionHistoryActionTypes = {
    TRANSACTION_HISTORY_FIRST: '@@transactionHistory/TRANSACTION_HISTORY_FIRST',
    TRANSACTION_HISTORY_LOADING: '@@transactionHistory/TRANSACTION_HISTORY_LOADING',
    TRANSACTION_HISTORY_SUCCESS: '@@transactionHistory/TRANSACTION_HISTORY_SUCCESS',
    TRANSACTION_HISTORY_ERROR: '@@transactionHistory/TRANSACTION_HISTORY_ERROR',
   
    DELETED_TRANSACTION_HISTORY_FIRST: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_FIRST',
    DELETED_TRANSACTION_HISTORY_LOADING: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_LOADING',
    DELETED_TRANSACTION_HISTORY_SUCCESS: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_SUCCESS',
    DELETED_TRANSACTION_HISTORY_ERROR: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_ERROR',

    DELETED_TRANSACTION_HISTORY_FIRST: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_FIRST',
    DELETED_TRANSACTION_HISTORY_LOADING: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_LOADING',
    DELETED_TRANSACTION_HISTORY_SUCCESS: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_SUCCESS',
    DELETED_TRANSACTION_HISTORY_ERROR: '@@transactionHistory/DELETED_TRANSACTION_HISTORY_ERROR',

    TRANSACTION_HISTORY_RESET: '@@transactionHistory/TRANSACTION_HISTORY_RESET',
}